/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import Grid from '@material-ui/core/Grid';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import {
    object, shape, arrayOf, string,
} from 'prop-types';
import { Link } from 'react-router-dom';
import { getPresentationFamily } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { trackData } from '../../../helpers/tracking/common/commonTrackingHelpers';

import Graphql404ErrorPage from './Graphql404ErrorPage';
import Graphql404ErrorCollectionContainer from './Graphql404ErrorCollectionContainer';
import Graphql404ErrorPlantsPage from './Graphql404ErrorPlantsPage';

const styles = (theme) => ({
    header: {
        WebkitFontSmoothing: 'antialiased',
        textAlign: 'center',
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '10px',
        },
    },
    oopsContainer: {
        lineHeight: '1.2',
        borderTop: `1px solid ${theme?.palette?.colorNeutral20}`,
        padding: '20px 0 20px 0',
    },
    oopsText: {
        color: theme?.palette?.colorNeutral70,
        fontFamily: 'Roboto, sans-serif',
        fontSize: '16px',
        letterSpacing: '.03em',
        textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
    },
    OopsText: {
        color: theme?.palette?.black,
        fontFamily: 'Roboto, sans-serif',
        fontSize: '28px',
        fontWeight: 'bold',
        // textShadow: '1px 1px 1px rgba(0, 0, 0, 0.004)',
    },
    break: {
        height: '12px',
        background: theme?.palette?.colorNeutral30,
        boxShadow: 'inset 0 1px 3px rgba(59,33,81,0.21), inset 0 1px 2px rgba(59,33,81,0.21)',
    },
    bestSellerContainer: {
        padding: '15px',
    },
    goodnewscontainer: {
        padding: '5px',
    },
    bestSellersText: {
        color: theme?.palette?.black,
        fontSize: '18px',
        fontWeight: 'bold',
    },
    goodnewsText: {
        color: theme?.palette?.black,
        fontSize: '14px',
    },
    links: {
        padding: '5px',
    },
    linksText: {
        color: theme?.palette?.black,
        fontSize: '14px',
        textDecoration: 'underline',
    },
    oopsTextContainer: {
        lineHeight: '1',
        width: '250px',
        margin: '0 auto',
        [theme.breakpoints.down('sm')]: {
            width: '180px',
        },
    },
    errorText: {
        color: theme.palette.colorPrimary,
        fontSize: '36px',
        letterSpacing: '0.36px',
        fontWeight: 600,
        '& span': {
            fontSize: '20px',
            fontWeight: 'normal',
            [theme.breakpoints.down('sm')]: {
                fontSize: '14px',
                paddingTop: '10px',
                display: 'block',
                lineHeight: '1.3',
            },
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
        },
    },
    errorImg: {
        paddingTop: '50px',
        [theme.breakpoints.down('sm')]: {
            paddingTop: '20px',
        },
        '& img': {
            width: '180px',
            [theme.breakpoints.down('sm')]: {
                width: '30%',
            },
        },
    },
});

const Graphql404ErrorPageBuilder = ({
    classes, brand, pageData, presentation_family, page,
}) => {
    trackData({
        action: 'track_404_data',
    });

    if ((pageData !== undefined || pageData !== null)) {
        const collection_copy = pageData?.findContentPage?.content?.entries[0]?.collection_copy;
        const collection_url = pageData?.findContentPage?.content?.entries[0]?.collection_url;
        const return_link = pageData?.findContentPage?.content?.entries[0]?.return_link;
        const collection_link = pageData?.findContentPage?.content?.entries[0]?.collection_link;
        const top_image = pageData?.findContentPage?.content?.entries[0]?.top_image;
        const top_copy = pageData?.findContentPage?.content?.entries[0]?.top_copy;
        return (
            <>
                {
                    presentation_family === 'flower'
                        && (
                            <>
                                <Grid className={classes.header}>
                                    <div className={classes.oopsContainer}>
                                        <span className={classes.oopsText}>{top_copy || null }</span>
                                    </div>
                                    <div className={classes.break} />
                                    <Grid className={classes.bestSellerContainer}>
                                        <span className={classes.bestSellersText}>{collection_copy || null}</span>
                                    </Grid>
                                </Grid>
                                <Graphql404ErrorCollectionContainer brand={brand} path={collection_url} />
                            </>
                        )
                }
                {
                    presentation_family === 'growthbrand'
                        && (
                            <div>
                                <Grid className={classes.header}>
                                    <Grid className={classes.errorImg}>
                                        <img src={top_image?.url || null} alt="topImage" />
                                    </Grid>
                                    <div className={classes.oopsTextContainer}>
                                        <span className={classes.errorText}>{ReactHtmlParser(top_copy) || null }</span>
                                    </div>
                                </Grid>
                                <Graphql404ErrorPage brand={brand} page={page} />
                            </div>
                        )
                }
                {
                    presentation_family === 'plants'
                        && (
                            <div>
                                <Graphql404ErrorPlantsPage brand={brand} page={page} image_url={top_image?.url || null} />
                            </div>
                        )
                }
                { presentation_family !== 'growthbrand' && presentation_family !== 'plants' && presentation_family !== 'flower' && (
                    <>
                        <Grid className={classes.header}>
                            <Link to={return_link?.href || null}>
                                <img src={top_image?.url || null} alt="topImage" />
                            </Link>
                            <Grid className={classes.goodnewscontainer}>
                                <span className={classes.goodnewsText}>{collection_copy || null}</span>
                            </Grid>
                            <Link to={collection_link?.href || null} className={classes.links}>
                                <span className={classes.linksText}>{collection_link?.title || null}</span><br />
                            </Link>
                            <Link to={return_link?.href || null}>
                                <span className={classes.linksText}>{return_link?.title || null}</span>
                            </Link>
                        </Grid>
                        <Graphql404ErrorCollectionContainer brand={brand} path={collection_url} />
                    </>
                )}

            </>
        );
    }
    return null;
};

Graphql404ErrorPageBuilder.propTypes = {
    classes: object.isRequired,
    brand: object.isRequired,
    presentation_family: string.isRequired,
    pageData: shape({
        findContentPage: shape({
            content: shape({
                entries: arrayOf(shape({
                    collection_copy: string.isRequired,
                    top_copy: string.isRequired,
                    collection_url: string.isRequired,
                    collection_link: shape({
                        title: string.isRequired,
                        href: string.isRequired,
                    }),
                    return_link: shape({
                        title: string.isRequired,
                        href: string.isRequired,
                    }),
                    top_image: shape({
                        title: string.isRequired,
                        url: string.isRequired,
                    }),
                })),
            }),
        }),
    }).isRequired,
    page: shape({
        path: string.isRequired,
    }).isRequired,
};
const mapStateToProps = (state) => ({
    presentation_family: getPresentationFamily(state),
});

export default connect(mapStateToProps)(withStyles(styles)(Graphql404ErrorPageBuilder));
